import React, { useEffect, useRef } from 'react';
import { closeDemoBookingModal } from '../../utils/functions';

const DemoBookingModal = () => {
  const calendlyContainerRef = useRef(null);

  // Ensure Calendly script is loaded
  useEffect(() => {
    if (!window.Calendly) {
      // Check if script already exists
      const existingScript = document.querySelector('script[src*="calendly.com/assets/external/widget.js"]');
      if (!existingScript) {
        // Load Calendly script if not already loaded
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        script.onload = () => {
          console.log('✅ Calendly script loaded');
        };
        script.onerror = () => {
          console.error('❌ Failed to load Calendly script');
        };
        document.body.appendChild(script);
      }
    }
  }, []);

  useEffect(() => {
    let calendlyInitialized = false;
    
    // Listen for modal open events and initialize Calendly
    const handleModalOpen = () => {
      const modal = document.getElementById('demo-booking-modal');
      if (modal && modal.style.display === 'block') {
        // Initialize Calendly widget when modal is open
        if (!calendlyInitialized && calendlyContainerRef.current) {
          const initCalendlyWidget = () => {
            const container = calendlyContainerRef.current;
            if (!container) return;
            
            // Check if Calendly script is loaded
            if (window.Calendly) {
              try {
                // Use initInlineWidget for inline embedding (not popup)
                window.Calendly.initInlineWidget({
                  url: 'https://calendly.com/it-bsbbrokersllp/30min',
                  parentElement: container
                });
                
                calendlyInitialized = true;
                console.log('✅ Calendly inline widget initialized successfully');
              } catch (error) {
                console.error('❌ Error initializing Calendly:', error);
                // Retry after delay
                setTimeout(initCalendlyWidget, 500);
              }
            } else {
              // Wait for Calendly script to load
              console.log('⏳ Waiting for Calendly script...');
              setTimeout(initCalendlyWidget, 300);
            }
          };

          // Wait for modal to be fully rendered and visible
          setTimeout(initCalendlyWidget, 800);
        }
      } else if (modal && modal.style.display === 'none') {
        // Reset flag when modal closes
        calendlyInitialized = false;
        // Clear Calendly widget when modal closes
        if (calendlyContainerRef.current) {
          calendlyContainerRef.current.innerHTML = '';
        }
      }
    };

    // Use MutationObserver to watch for style changes on modal
    const modal = document.getElementById('demo-booking-modal');
    if (modal) {
      const observer = new MutationObserver(handleModalOpen);
      observer.observe(modal, {
        attributes: true,
        attributeFilter: ['style'],
        childList: false,
        subtree: false
      });

      // Also check periodically as backup
      const interval = setInterval(handleModalOpen, 500);
      
      return () => {
        observer.disconnect();
        clearInterval(interval);
      };
    }
  }, []);

  return (
    <div id="demo-booking-modal" className="modal demo-modal" style={{ display: 'none' }}>
      <div className="modal-content demo-modal-content">
        <div className="demo-modal-top-bar">
          <button 
            type="button" 
            className="close-modal-top" 
            onClick={closeDemoBookingModal} 
            aria-label="Close"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
        <div className="demo-modal-header">
          <div className="demo-type-badge" id="demo-type-badge" style={{ display: 'none' }}>
            <i className="fas fa-tag"></i>
            <span id="demo-type-badge-text"></span>
          </div>
          <h2 id="demo-modal-title">Book a Demo</h2>
          <p className="demo-subtitle">Schedule a personalized demo for <strong id="demo-type-text">your business</strong></p>
        </div>
        
        {/* Calendly Widget Only */}
        <div className="calendly-section" style={{ marginTop: '20px', paddingTop: '20px' }}>
          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/it-bsbbrokersllp/30min" 
            style={{ minWidth: '320px', height: '700px', width: '100%' }}
            ref={calendlyContainerRef}
            id="calendly-container"
          ></div>
        </div>
      </div>
    </div>
  );
};

export default DemoBookingModal;
